(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-product-sticky"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-sticky')) {
    customElements.define(
      'product-sticky',
      class ProductSticky extends HTMLElement {
        connectedCallback() {
          document.body.classList.add('c-product-sticky-enabled');
          this.form = this.querySelector('.c-product-sticky__form');
          this.form?.addEventListener('submit', this.handleSubmit);
          this.updateHeight = () => {
            document.documentElement.style.setProperty('--sl-c-product-sticky-height', `${this.offsetHeight}px`);
          };
          this.resizeObserver = new ResizeObserver(this.updateHeight);
          this.resizeObserver.observe(this);
          this.updateHeight();
        }

        disconnectedCallback() {
          this.form?.removeEventListener('submit', this.handleSubmit);
          this.resizeObserver?.disconnect();
          if (!document.querySelector('product-sticky')) {
            document.body.classList.remove('c-product-sticky-enabled');
            document.documentElement.style.removeProperty('--sl-c-product-sticky-height');
          }
        }

        handleSubmit = async (event) => {
          event.preventDefault();

          const button = this.form.querySelector('[type="submit"]');
          const errorElement = this.form.querySelector('.c-product-sticky__error');
          if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

          const quantitiesByVariant = new Map();
          const addItem = (variantId, quantity) => {
            if (!variantId) return;
            quantitiesByVariant.set(variantId, (quantitiesByVariant.get(variantId) || 0) + Number(quantity));
          };

          addItem(this.form.dataset.primaryVariantId, this.form.dataset.primaryQuantity);
          addItem(this.form.dataset.secondaryVariantId, this.form.dataset.secondaryQuantity);

          const items = Array.from(quantitiesByVariant, ([id, quantity]) => ({ id, quantity }));
          const sections = [];
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
          );

          button.setAttribute('aria-disabled', 'true');
          button.setAttribute('aria-busy', 'true');
          button.classList.add('btn--loading');
          errorElement.hidden = true;

          try {
            const response = await fetch(FoxTheme.routes.cart_add_url, {
              ...FoxTheme.utils.fetchConfig('javascript'),
              body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
            });
            const parsedState = await response.json();

            if (!response.ok || parsedState.status) {
              throw new Error(parsedState.description || parsedState.message || 'Unable to add products to cart.');
            }

            const cartResponse = await fetch(FoxTheme.routes.cart_url, FoxTheme.utils.fetchConfig());
            const cartJson = await cartResponse.json();
            cartJson.sections = parsedState.sections;

            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
            document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsedState } }));
            document.querySelector('cart-drawer')?.show(button);
          } catch (error) {
            errorElement.textContent = error.message;
            errorElement.hidden = false;
            document.dispatchEvent(
              new CustomEvent('product-ajax:error', { detail: { errorMessage: error.message } })
            );
          } finally {
            button.classList.remove('btn--loading');
            button.removeAttribute('aria-disabled');
            button.removeAttribute('aria-busy');
          }
        };
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
